import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M32.685 17.066 20.779 5.319a1 1 0 0 0-.17-.135c-.027-.016-.06-.032-.088-.049-.033-.016-.066-.038-.104-.054s-.077-.021-.115-.032c-.033-.011-.06-.022-.093-.027A1 1 0 0 0 19.994 5a1 1 0 0 0-.213.022.4.4 0 0 0-.088.027q-.058.014-.116.038a1 1 0 0 0-.098.054c-.028.016-.06.027-.088.048-.06.038-.115.087-.17.136L7.32 17.066a1.075 1.075 0 0 0 0 1.532c.214.211.494.32.774.32s.56-.109.773-.32l10.035-9.9v25.22c0 .595.494 1.082 1.097 1.082.604 0 1.097-.487 1.097-1.083V8.697l10.035 9.901c.214.211.494.32.773.32.28 0 .56-.109.774-.32a1.074 1.074 0 0 0 0-1.532z"
    }, null, -1)
  ]))]))
}
export default { render: render }